export default "__VITE_ASSET__BsdM_Jns__"